import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-20 lg:py-[140px] px-8 lg:px-[60px] max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-[120px] items-center" data-id="element-15">
      {/* Visual */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative h-[400px] lg:h-[600px]" data-id="element-16">
        <div className="absolute inset-0 bg-charcoal2 border border-glass-border rounded-sm overflow-hidden" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/vvH6QGTkKficcEon3zBgjo/private_openrouter-generated-image-1778348228971.png" alt="Elias Navarro - Founding Attorney" className="w-full h-full object-cover object-center" data-id="element-18" />
          {/* Cinematic gradient overlays for mood and badge readability */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-19"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-black/40" data-id="element-20"></div>
          {/* Corner accents */}
          <div className="absolute top-5 left-5 w-[30px] h-[30px] border-t-2 border-l-2 border-crimson z-10" data-id="element-21"></div>
          <div className="absolute bottom-5 right-5 w-[30px] h-[30px] border-b-2 border-r-2 border-crimson z-10" data-id="element-22"></div>
        </div>

        <div className="absolute -bottom-5 -right-5 lg:-bottom-5 lg:-right-5 bg-crimson p-6 lg:px-8 lg:py-6 rounded-sm shadow-2xl" data-id="element-23">
          <span className="font-serif text-3xl lg:text-[36px] font-black text-white block leading-none mb-1" data-id="element-24">
            {t('about.tag.years')}
          </span>
          <span className="text-[9px] tracking-[3px] uppercase text-white/70" data-id="element-25">
            {t('about.tag.text')}
          </span>
        </div>
      </motion.div>

      {/* Content */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.1
    }} data-id="element-26">
        <p className="font-sans text-[10px] tracking-[6px] uppercase text-crimson-glow font-medium mb-6 flex items-center gap-5 before:content-[''] before:w-[40px] before:h-px before:bg-gradient-to-r before:from-crimson-glow before:to-transparent opacity-90" data-id="element-27">
          {t('about.label')}
        </p>
        <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[64px] font-medium leading-[1.05] tracking-[-0.02em] text-white mb-8" dangerouslySetInnerHTML={{
        __html: t('about.headline')
      }} data-id="element-28" />
        <p className="font-sans text-[15px] lg:text-[17px] leading-[1.9] text-white/50 font-light tracking-[0.02em] max-w-[600px]" data-id="element-29">
          {t('about.body')}
        </p>

        <ul className="list-none mt-12 flex flex-col gap-5" data-id="element-30">
          {[t('about.list.1'), t('about.list.2'), t('about.list.3'), t('about.list.4'), t('about.list.5')].map((item, i) => <li key={i} className="flex items-center gap-5 font-sans text-[14px] lg:text-[15px] text-white/60 font-light tracking-[0.02em] before:content-[''] before:w-6 before:h-px before:bg-gradient-to-r before:from-crimson before:to-transparent before:shrink-0" data-id="element-31">
              {item}
            </li>)}
        </ul>
      </motion.div>
    </section>;
}